import CampaignLoyaltyProgramPanel from './campaignLoyaltyProgram.container';

export default CampaignLoyaltyProgramPanel;